import styled from "styled-components";


import Material2 from "./Material";
import useBIMClass from "../../../../../../clients/taxonomy/useBIMClass";
import * as UI from "../../../../../../modules/ui-kit";

const Styled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 32px;
`;

export default function Materials(props) {
    const { bimClass: bimClassID, disabled, onChange, value } = props;

    const bimClass = useBIMClass(bimClassID);
    if (!bimClass.data?.bimClass) return undefined;

    function update(material, update) {
        /*
        Add component
         */
        if (!material) {
            onChange([...value, update]);
            return;
        }

        /*
        Remove component
         */
        if (!update) {
            onChange(
                value.toSpliced(
                    value.indexOf(material),
                    1,
                )
            );
            return;
        }

        /*
        Change component
         */
        onChange(
            value.with(
                value.indexOf(material),
                {
                    ...material,
                    ...update,
                },
            )
        );
    }

    return (
        <Styled>
            {
                value.map(
                    (material) => (
                        <Material2
                            bimClass={ bimClass }
                            disabled={ disabled }
                            key={ material.id }
                            id={ material.id }
                            properties={ material.properties }
                            onChange={ (updateSpec) => update(material, updateSpec) }
                            onRemove={ () => update(material, undefined) }
                        />
                    )
                )
            }
            <UI.Button
                disabled={ disabled }
                onClick={ () => onChange([...value, { materialIdentifier: { id: "" } }])}
            >
                Add material
            </UI.Button>
        </Styled>
    );
}
